const errorAws: any = {
  LimitExceededException: "Se ha superado el número máximo de intentos. Intente nuevamente más tarde",
  CodeMismatchException: "El código que ingresaste no es válido",
  NotAuthorizedException: "No estás autorizado para realizar esta operación",
  ExpiredCodeException: "El código utilizado ha expirado. Solicite un nuevo código",
  NetworkError: "Problemas de conexión. Inténtalo en una red más estable",
}

export default errorAws
